module.exports = __webpack_public_path__ + "static/process-3f65236fb2e682bb726db5f9c7d010c7.png";